export default __webpack_public_path__ + "static/website_command-b6955ea342e43ffad27ce0bd9fd4e837.png";